import { cloneDeep } from 'lodash';

// Largeurs de colonnes (px) — partagées par toutes les listes redimensionnables (table-layout: fixed).
// DEFAULT reprend l'ancienne classe .ft-listHead-fixedWidth (144px) → rendu identique tant qu'aucune colonne n'est redimensionnée.
export const DEFAULT_COLUMN_WIDTH = 144;
export const MIN_COLUMN_WIDTH = 60;
export const CHECKBOX_COLUMN_WIDTH = 48;

// Type structurel minimal : compatible avec n'importe quel Column (cms/objects ou utils/list/objects)
// du moment qu'il porte field_name + width.
export type ResizableColumn = { field_name: string; width?: number | null };

export type ColumnResizePayload = { field_name: string; width: number };

// Largeur effective d'une colonne.
// Tant qu'aucune préférence width n'est chargée, on garde une largeur par défaut
// identique à l'ancien rendu (.ft-listHead-fixedWidth) pour stabiliser le header.
// Après redimensionnement, on réutilise la largeur persistée.
export const columnWidth = (column: ResizableColumn): number | undefined =>
    column.width ?? DEFAULT_COLUMN_WIDTH;

// Applique une largeur à la colonne ciblée et renvoie un NOUVEAU tableau (immutable, cloneDeep).
// À utiliser dans un reducer RTK :
//   resizeColumn(state, action) { state.xxx.columns = applyColumnResize(state.xxx.columns, action.payload); }
export const applyColumnResize = <T extends ResizableColumn>(columns: T[], payload: ColumnResizePayload): T[] => {
    const next = cloneDeep(columns);
    const target = next.find(c => c.field_name === payload.field_name);
    if (target) target.width = payload.width;
    return next;
};
